import AlertPanel from '@/components/Notifications/AlertPanel.vue'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Vuetify from 'vuetify'

export default {
  computed: {
    ...mapGetters(['currentUser'])
  },
  methods: {
    displayMessage(message, exception, scope, gravity, duration) {
      this.exception = exception || ''
      this.scope = scope
      this.gravity = gravity || 'success'
      if (scope === 'notification') {
        this.$notify({
          group: 'notifications',
          type:
            this.currentUser != null && this.currentUser.type === 'demo'
              ? 'warning'
              : this.gravity,
          duration: duration || -1,
          title: message + ' - Click to dismiss',
          text: this.getErrorMessage(exception)
        })
      } else {
        let element = this.$refs[this.scope]
        if (element) {
          let ComponentClass = Vue.extend(AlertPanel)
          let instance = new ComponentClass({
            vuetify: new Vuetify(),
            propsData: {
              exception: message + ' ' + this.getErrorMessage(exception),
              gravity: this.gravity
            }
          })
          instance.$mount()
          element.appendChild(instance.$el)
        }
      }
    },
    getErrorMessage(error) {
      let message = ''
      if (error && error.message) {
        message += ' ' + error.message
        if (error.response) {
          // axios message handling
          switch (error.response.status) {
            case 504:
              message = 'Server not available, please contact the support team.'
              break
            case 500:
              message =
                'Internal server error, please contact the support team.'
              break
            case 400:
              let errorMsg = error.response.data
              if (errorMsg != null && errorMsg.message != null) {
                message = 'Bad request (' + errorMsg.message + ')'
              } else {
                message = 'Bad request (' + error.response.data + ')'
              }
              message = this.friendlifyParseError(message)
              break
            case 401:
              this.forceLogout()
              break
            case 403:
              if (error.response.data?.message === 'Access Denied') {
                // spring middleware rejected the token
                this.forceLogout()
              } else {
                message =
                  'Restricted data, authorization failed, please upgrade your account.'
              }
              break
            case 404:
              message =
                'Resource not found. Your data must be out of date, please refresh your browser.'
              break
            case 409:
              message = 'Conflict (' + error.response.data + ')'
              break
            default:
              message = error.response.data
          }
        }
      } else if (error && !error.message) {
        message = error
      }
      return message
    },

    friendlifyParseError(message){
      if (message.includes('Bad request (JSON parse error:')) {
        let middleError = message.split('JSON parse error: ')[1]
        middleError = middleError.split('; nested exception is')[0]

        let errorOrigin = message.split('["')[1]
        errorOrigin = errorOrigin.split('"]')[0]

        return 'Bad request (' + middleError +') at field \''+errorOrigin+'\''
      }
      else{
        return message
      }
    },

    forceLogout() {
      this.$root.$emit('request-logout')
    }
  }
}
